/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { customer } from '../models/customer';
import type { dataTablesRequest } from '../models/dataTablesRequest';
import type { vw_customer } from '../models/vw_customer';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CustomerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postCustomerDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/customer/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve a list of customers
     * @returns vw_customer A list of customer
     * @throws ApiError
     */
    public getCustomer(): CancelablePromise<Array<vw_customer>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/customer',
        });
    }

    /**
     * Create a new Customer
     * @returns any Customer created successfully
     * @throws ApiError
     */
    public postCustomer({
        requestBody,
    }: {
        requestBody: customer,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/customer',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update an existing Customer
     * @returns any Customer updated successfully
     * @throws ApiError
     */
    public putCustomer({
        requestBody,
    }: {
        requestBody: customer,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/customer',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Customer not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get default customer by store
     * @returns vw_customer The customer data
     * @throws ApiError
     */
    public getCustomerDefault({
        storeId,
    }: {
        storeId: string,
    }): CancelablePromise<vw_customer> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/customer/default',
            query: {
                'storeId': storeId,
            },
            errors: {
                404: `Customer not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a customer by id
     * @returns any Customer deleted successfully
     * @throws ApiError
     */
    public deleteCustomer({
        id,
    }: {
        /**
         * The customer id
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/customer/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Customer not found`,
                500: `Internal server error`,
            },
        });
    }

}
